<template>
  <div>
    <div v-if="leftBtn.length > 0" style="margin-bottom: 16px;">
      <template v-for="(item, index) in leftBtn">
        <dy-button
          v-if="!item.slot"
          :key="index"
          :type="item.right === 'right'? 'text': index == 0 ? 'break' : ''"
          :class="{ floatRight: item.right === 'right', btnAlignCenter: item.rightAlignCenter }"
          :style="item.right === 'right'? (item.rightStyle? item.rightStyle : 'margin-bottom: 16px'): ''"
          @click="handleLeftBtn(item)"
          >{{ item.text }}
        </dy-button>
        <slot v-else :name="item.slot"></slot>
      </template>
    </div>
    <el-table
      class="my-table"
      style="width: 100%"
      :data="tableData"
      :row-key="rowKey"
      :max-height="maxHeight"
      v-loading="loading"
      ref="tableRef"
      border
      @selection-change="handleSelectionChange"
      @sort-change="changeTableSort"
      row-class-name="tableRowClassName"
      v-bind="$attrs"
      v-on="$listeners"
      :header-cell-style="{ background: '#F8F9FA' }"
    >
      <el-table-column
        v-if="selection"
        type="selection"
        :width="selectableWidth? selectableWidth: '55'"
        :reserve-selection="true"
        :selectable="selectable"
      >
      </el-table-column>

      <template v-for="(item, index) in tableInfo">
        <el-table-column
          v-if="!item.noShow && item.type == 'index'"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :min-width="item.minWidth"
          :fixed="item.fixed"
          :sortable="item.sortable"
          type="index"
        >
        </el-table-column>
        <el-table-column
          v-else-if="!item.noShow && item.type == 'scalable'"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :min-width="item.minWidth"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :show-overflow-tooltip="!showOverflow"
        >
          <template slot="header" slot-scope="scope">
            {{ item.label }}
            <dy-button v-if="!showOverflow" @click="showOverflow = !showOverflow" type="blueText">
              展开<i class="new-down-icon-box" style="margin: -3px 0"></i>
            </dy-button>
            <dy-button v-else @click="showOverflow = !showOverflow" type="blueText">
              收起<i class="new-top-icon-box" style="margin: -3px 0"></i>
            </dy-button>
          </template>
          <template slot-scope="scope">
            <div
              class="hoveTitle"
              style="-webkit-box-orient: vertical;"
              v-if="!showOverflow"
            >
              {{ scope.row[item.prop] }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="!item.noShow && item.type == 'scalable2'"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :min-width="item.minWidth"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :show-overflow-tooltip="!showOverflow2"
        >
          <template slot="header" slot-scope="scope">
            {{ item.label }}
            <dy-button v-if="!showOverflow2" @click="showOverflow2 = !showOverflow2" type="blueText">
              展开<i class="new-down-icon-box" style="margin: -3px 0"></i>
            </dy-button>
            <dy-button v-else @click="showOverflow2 = !showOverflow2" type="blueText">
              收起<i class="new-top-icon-box" style="margin: -3px 0"></i>
            </dy-button>
          </template>
          <template slot-scope="scope">
            <div
              class="hoveTitle"
              style="-webkit-box-orient: vertical;"
              v-if="!showOverflow2"
            >
              {{ scope.row[item.prop] }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>

        <el-table-column
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :min-width="item.minWidth"
          :fixed="item.fixed"
          :sortable="item.sortable"
          v-else-if="!item.noShow"
          :show-overflow-tooltip="
            showOverflowTooltip || item.showOverflowTooltip
          "
        >
          <template #header="scope" v-if="item.slotHead">
            <slot :name="item.slotHead" :column="scope.column"></slot>
          </template>
          <template slot-scope="scope">
            <slot
              :name="item.slot"
              :row="scope.row"
              :rowIndex="scope.$index"
              :textWrap="item.textWrap"
              v-if="item.slot"
            ></slot>
            <template v-else-if="item.type == 'tips'">
              <div>
                <div :class="{ textHidden: !item.textWrap }">
                  {{ scope.row[item.prop] }}
                  <el-tooltip
                    effect="dark"
                    :content="scope.row[item.tipsKey]"
                    placement="top-start"
                  >
                    <span v-if="scope.row[item.tipsKey]" style="cursor:pointer"
                      >?</span
                    >
                  </el-tooltip>
                </div>
              </div>
            </template>
            <template v-else>
              <div>
                <div :class="{ textHidden: !item.textWrap }">
                  <!-- {{ scope.row[item.prop] }} -->
                  <span v-if="isNeedBar"> {{ scope.row[item.prop]? scope.row[item.prop] : '-' }}</span>
                  <span v-else> {{ scope.row[item.prop] }}</span>
                  <span v-if="item.arrow">
                    <i
                      v-if="scope.row[item.arrowKey] === item.arrowRule[0]"
                      class="el-icon-caret-top"
                      style="color: #fe4d45"
                    ></i>
                    <i
                      v-else-if="scope.row[item.arrowKey] === item.arrowRule[1]"
                      class="el-icon-caret-bottom"
                      style="color: #49c568"
                    ></i>
                  </span>
                  
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
      <slot v-if="!tableInfo.length" />
      <!-- <template slot="empty" v-if="isDefaultEmpty">
        <div style="text-align: center;">
          <img :src="$globalCdn + '/images/default/暂无任何数据.png'" />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template> -->
      <template slot="empty" v-else>
        <slot name="empty"></slot> 
      </template>
    </el-table>
    <!-- 分页组件 -->
    <div style=" margin: 20px 0" class="new-pagination-page" v-if="showPage">
      <el-pagination
        style="text-align: right;"
        :currentPage="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        :page-sizes="[10, 30, 50, 100, 1000]"
        :background="background"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-show="!pageInfo.noShow"
      />
    </div>
  </div>
</template>

<script>
/**
 * 表格参数除porps定义的以外 其余与element一致，
 *
 *
 * 列参数
 * 参数定义与element一致部分：
 * prop
 * label
 * width
 * align
 * min-width
 * fixed
 * sortable
 * showOverflowTooltip
 * arrow ：展示上下箭头
 * arrowKey : 判断上升下降的字段
 * arrowRule : [a,b,c]对应 上升 下降 不变
 *
 * 单独定义
 * type：
 *    index 序号列
 *    tips 末尾有问号，悬浮后有提示文本
 *    scalable 展开&收起
 *
 * 表头按钮
 * leftBtn | Array
 *  text : 按钮文案
 *  handle : 点击按钮的回调事件 建议 Btn 结尾避免与其他事件同名
 *  isBatch : 是否是批量按钮
 *  btnAlignCenter: 文字按钮高度给34px，居中
 *
 * 分页器
 * pageNum: 1,
 * pageSize: 10,
 * total: 0, 总条数 也可不在pageInfo传，直接传total
 * noShow  传true 不展示分页器，不传或传false则展示
 */

export default {
  props: {
    tableInfo: {
      type: Array,
      default: () => [],
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    reserveSelection:{
      type: Boolean,
      default: false,
    },
    // 分页信息
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        };
      },
    },
    // 数据总数 也可放于pageInfo里
    total: {
      type: Number,
      default: 0,
    },
    // 表头按钮
    leftBtn: {
      type: Array,
      default: () => [],
    },
    // 多选列
    selection: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      // 换页也勾选中（数据唯一值）
      type: null,
      default: "",
    },
    // 加载中
    loading: {
      type: Boolean,
      default: false,
    },
    // 没有数据时显示提示
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    // table最大高度，默认不传
    maxHeight: {
      type: String,
     
    },
    // 多选选中数据--用于多选数据回显
    // 注意：其中的对象需要和表格列表中的对应项完全一致
    selectList: {
      type: Array,
      default: () => [],
    },
    //  当内容过长被隐藏时显示 tooltip
    showOverflowTooltip: {
      type: Boolean,
      default: false,
    },

    // 仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    selectable: {
      type: Function,
      default: (row, index) => {
        return (row, index) => {
          return true;
        };
      },
    },
    selectableWidth: {
      type: String,
    },
    horizontalScroll:{
      type:String,
      default: "always"
    },

    //分页器的背景色
    background:{
      type:Boolean,
      default:true
    },
    // 导出提示语
    exportTip:{
      type:String,
      default:'请先勾选数据后再操作'
    },
    //使用默认的空数据提示
    isDefaultEmpty: {
      type:Boolean,
      default:true
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    // 无数据时是否需要显示为 - 
    isNeedBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ids: [],
      showOverflow: false, // 因目前每个列表顶多只会需要一个 showOverflow，所以暂不考虑多个的情况
      showOverflow2: false, // 因目前有些列表顶需要两个 showOverflow，所以暂不考虑多个的情况
    };
  },
  computed: {
    tableTotal() {
      return Number(this.total) || Number(this.pageInfo.total) || 0;
    },
  },
  created() {
    console.log(this.tableInfo,'666');
  },
  methods: {
    // 清空排序
    handleClearSort() {
      this.$refs.tableRef.clearSort()
    },
    handleClearSelection() {
      this.$refs.tableRef.clearSelection()
    },
    changeTableSort(val) {
      this.$emit("changeTableSort", val);
    },
    handleSelectionChange(val) {
      this.ids = [...val];
      this.$emit("selection-change", this.ids);
      this.$emit("handleSelectionChange", this.ids);
    },
    handleLeftBtn(item) {
      if (item.isBatch) {
        if (this.ids.length > 0) {
          this.$emit(item.handle, this.ids);
        } else {
          this.$message.warning(this.exportTip);
        }
      } else {
        console.log(this.ids);
        this.$emit(item.handle, this.ids);
      }
    },
    //分页
    handlePage(page) {
      this.$emit("handlePage", page);
    },
    handleSizeChange(val) {
      this.handlePage({ pageSize: val, pageNum: 1 });
    },
    handleCurrentChange(val) {
      this.handlePage({ pageSize: this.pageInfo.pageSize, pageNum: val });
    },
    toggleRowSelection(row, selected = false) {
      let that = this;
      return that.$refs.tableRef.toggleRowSelection(row, selected);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .my-table {
  border: 1px solid #F2F2F2;
  border-bottom: none;
  border-radius: 4px;
  .el-table__header th.el-table__cell {
    font-size: 14px;
    color: #333333;
    // background: #f8f9fa;
    font-weight: 400 !important;
    min-height: 48px;
  }
  .tableRowClassName .cell {
    min-height: 48px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  // 列表行
  .textHidden {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  // .has-gutter {
  //   height: 40px;
  // }
  .el-table__footer-wrapper .el-table__footer .el-table__cell{
    // color: #2768FF !important;
    font-weight: 600 !important;
  }
  
  .el-table__footer-wrapper .el-table__footer .el-table__cell:first-child {
    color: #333 !important;
  }
  .el-table .el-table__cell.gutter {
    background: #FAFAFA;
  }
}

.dropColor {
  line-height: 53px;
  color: #715dff;
  &:hover {
    text-decoration: underline;
  }
}

::v-deep .el-table .el-table__cell {
  padding: 0px 0 1px 0;
}
.btnRight {
  width: 65px;
  color: #715dff;
  display: flex;
  font-size: 13px;
  justify-content: space-between;
  .btnRightItem.disabled {
    color: #cccccc;
  }
  .btnRightItem.del {
    color: #ee1a33;
  }
}
.floatRight {
  float: right;
}
.btnAlignCenter {
  height: 34px;
  line-height: 34px;
}
.show_hide {
  font-size: 14px;
  color: #715dff;
  cursor: pointer;
}
.hoveTitle {
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
